import React from 'react';
import {
  CHECKBOXES,
  DROPDOWN,
  EMAIL,
  NUMBER,
  RADIO_BUTTONS,
  TEXT,
  UNDEFINED,
  DROPDOWNS_GROUP,
  PHONE_NUMBER,
  PP_DROPDOWN,
  DROPDOWN_WITH_OTHER,
} from '../../constants/fieldTypes';

import { FormTextPreview } from '../previewFields/FormTextPreview.ts/FormTextPreview';
import FormDropdownPreview from '../previewFields/FormDropdownPreview/FormDropdownPreview';
import { FormFieldPreviewProps } from '../previewFields/FormFieldPreview/FormFieldPreview';
import FormDropdownsGroupPreview from '../previewFields/FormDropdownsGroupPreview/FormDropdownsGroupPreview';
import { FormDropdownWithOtherPreview } from '../previewFields/FormDropdownWithOtherPreview/FormDropdownWithOtherPreview';

export type FormFieldPreviewTypes =
  | typeof TEXT
  | typeof EMAIL
  | typeof DROPDOWN
  | typeof RADIO_BUTTONS
  | typeof CHECKBOXES
  | typeof NUMBER
  | typeof PHONE_NUMBER
  | typeof UNDEFINED
  | typeof DROPDOWNS_GROUP
  | typeof PP_DROPDOWN
  | typeof DROPDOWN_WITH_OTHER;

export const formFieldsPreviewConfig: Record<
  FormFieldPreviewTypes,
  (fieldProps: FormFieldPreviewProps) => React.JSX.Element | undefined
> = {
  text: (fieldProps: FormFieldPreviewProps) => {
    return <FormTextPreview {...fieldProps} />;
  },
  email: (fieldProps: FormFieldPreviewProps) =>
    formFieldsPreviewConfig.text(fieldProps),
  dropdown: (fieldProps: FormFieldPreviewProps) => {
    return <FormTextPreview {...fieldProps} />;
  },
  pp_dropdown: (fieldProps: FormFieldPreviewProps) => {
    return <FormDropdownPreview {...fieldProps} />;
  },
  dropdowns_group: (fieldProps: FormFieldPreviewProps) => {
    return <FormDropdownsGroupPreview {...fieldProps} />;
  },
  dropdown_with_other: (fieldProps: FormFieldPreviewProps) => {
    return <FormDropdownWithOtherPreview {...fieldProps} />;
  },
  radio_buttons: (fieldProps: FormFieldPreviewProps) => {
    return <FormTextPreview {...fieldProps} />;
  },
  checkboxes: (fieldProps: FormFieldPreviewProps) => {
    return <FormTextPreview {...fieldProps} />;
  },
  number: (fieldProps: FormFieldPreviewProps) => {
    return <FormTextPreview {...fieldProps} />;
  },
  phone_number: (fieldProps: FormFieldPreviewProps) => {
    return <FormTextPreview {...fieldProps} />;
  },
  undefined: (...args: unknown[]) => undefined,
};
